import { useCallback, useMemo, useState } from 'react';

export type BasicFlowPage = 'CHECKS_AND_WARMUP' | 'GOALS' | 'CONVERSATION' | 'RESULTS' | 'CHATLOG';

const basicFlow: {[page in BasicFlowPage]: number} = {
    CHECKS_AND_WARMUP: 0,
    GOALS: 1,
    CONVERSATION: 2,
    RESULTS: 3,
    CHATLOG: 4
};

const NUMBER_OF_PAGES = 4; // Not counting checks and warmup

export function usePageInfo() {
    const [currentPage, setCurrentPage] = useState<number>(0);

    const updateCurrentPage = useCallback((page: BasicFlowPage) => {
        setCurrentPage(basicFlow[page]);
    }, [setCurrentPage]);

    return useMemo(() => ({
        currentPage,
        totalPages: NUMBER_OF_PAGES,
        updateCurrentPage
    }), [currentPage, updateCurrentPage])
}